import ErrorComponent from '@/components/Pages/Error.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/error',
  name: RouteNames.Error,
  component: ErrorComponent,
};

export default route;
